import request from "../request";

/**
 *  打卡月统计数据分页
 */
export function selectStatisticsData(query) {
    return request({
        url: 'sys/attendanceClockInWeb/GetClockInStatisticsData',
        method: 'POST',
        data: query,
    })
}
/**
 *  导出-月统计打卡
 */
export function exportStatistics(query) {
    return request({
        url: 'sys/attendanceClockInWeb/exportClockInStatisticsData',
        method: 'POST',
        data: query,
    })
}

/**
 *  打卡时间数据分页
 */
export function selectClockInTime(query) {
    return request({
        url: 'sys/attendanceClockInWeb/GetClockInData',
        method: 'POST',
        data: query,
    })
}
/**
 *  导出-打卡时间
 */
export function exportClockInTime(query) {
    return request({
        url: 'sys/attendanceClockInWeb/exportClockInData',
        method: 'POST',
        data: query,
    })
}

/**
 *  每日统计数据分页
 */
export function selectDayStatistics(query) {
    return request({
        url: 'sys/attendanceClockInWeb/GetDailyStatistics',
        method: 'POST',
        data: query,
    })
}
/**
 *  导出-每日统计
 */
export function exportDayStatistics(query) {
    return request({
        url: 'sys/attendanceClockInWeb/exportDailyStatistics',
        method: 'POST',
        data: query,
    })
}


/**
 *  每日统计数据分页
 */
export function selectOriginalRecord(query) {
    return request({
        url: 'sys/attendanceClockInWeb/GetOriginalRecord',
        method: 'POST',
        data: query,
    })
}
/**
 *  导出-每日统计
 */
export function exportOriginalRecord(query) {
    return request({
        url: 'sys/attendanceClockInWeb/exportOriginalRecord',
        method: 'POST',
        data: query,
    })
}